@if ((hasMenu$ | async)) {
  <button class='menu-item'
    (click)='invoke()'
    [csActiveTool]='commandName'
    (deactivated)='itemDeactivated()'
    [disabled]='shouldDisable$|async'
    [cdkMenuTriggerFor]='subMenu'
    cdkMenuItem>
    @if (!!icon) {
      <mat-icon [svgIcon]='icon'></mat-icon>
    }
    <span>{{ (customLabel$ | async) ?? label }}</span>
  </button>
}

@if (!(hasMenu$ | async)) {
  <button class='menu-item'
    (click)='invoke()'
    [csActiveTool]='commandName'
    (deactivated)='itemDeactivated()'
    [disabled]='shouldDisable$|async'
    cdkMenuItem>
    @if (!!icon) {
      <mat-icon [svgIcon]='icon'></mat-icon>
    }
    <span>{{ (customLabel$ | async) ?? label }}</span>
  </button>
}

<ng-template  #subMenu>
  <dash-gis-sub-menu [menuItems]='widgetMenuItems$ | async'></dash-gis-sub-menu>
</ng-template>
